import styled from 'styled-components/native';

const Root = styled.View`
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
`;

export default Root;
